import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Right } from './classes/Right';

import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';

import { RoutingGuardService } from './services/routing-guard.service';
import { ConfigurationComponent } from './components/configuration/configuration.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';

const routes: Routes = [
  {
    path: '', redirectTo: '', pathMatch: 'full', component: HomeComponent, canActivate: [RoutingGuardService],
    data: {
      title: "home", requireUser: true
    }
  },
  {
    path: 'login', component: LoginComponent, canActivate: [RoutingGuardService],
    data: {
      title: "login", requireUser: false
    }
  },
  {
    path: 'config', component: ConfigurationComponent, canActivate: [RoutingGuardService],
    data: {
      title: "configuration", requireUser: true, right: Right.SSO
    }
  },
  {
    path: 'user-profile', component: UserProfileComponent, canActivate: [RoutingGuardService],
    data: {
      title: "profile", icon: "fa-user", requireUser: true, right: Right.SSO
    }
  },
  { //i.e. localhost:9090/123 ; for routes without a component, they must be placed last so they don't conflict with path: ''
    path: '**', redirectTo: '', data: null
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
